import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Card, CardMedia, CardContent, Button, CircularProgress, Chip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import superAdminService from '../services/superAdminService';

const SuperAdminImages = () => {
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const data = await superAdminService.getAllImages();
        
        // FIX: Extract the 'images' array from the wrapper object
        if (data.images && Array.isArray(data.images)) {
            setImages(data.images);
        } else if (Array.isArray(data)) {
            setImages(data); // Fallback if API changes to return just array
        } else {
            setImages([]);
        }
      } catch (error) {
        console.error("Failed to load images", error);
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  if (loading) return <CircularProgress sx={{ m: 5 }} />;

  return (
    <Box sx={{ p: 3 }}>
      <Button 
        startIcon={<ArrowBackIcon />} 
        onClick={() => navigate('/super-admin/dashboard')}
        sx={{ mb: 3 }}
      >
        Back to Dashboard
      </Button>
      
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold' }}>
        System Images ({images.length})
      </Typography>

      <Grid container spacing={2}>
        {images.map((img, index) => (
          // Use img.id if available, otherwise use index to prevent crash
          <Grid item key={img.id || index} xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardMedia
                component="img"
                height="200"
                image={img.imageUrl} // Updated from log
                alt="Survey Upload"
                sx={{ objectFit: 'cover' }}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ mb: 1 }}>
                    <Chip label={img.dealerName || 'Unknown Dealer'} size="small" color="primary" sx={{ mb: 1 }} />
                </Box>
                
                <Typography variant="subtitle2" fontWeight="bold">
                   {img.surveyTitle || 'Untitled Survey'}
                </Typography>
                
                <Typography variant="body2" color="text.secondary">
                   Customer: {img.customerName || 'Anonymous'}
                </Typography>

                <Typography variant="caption" display="block" sx={{ mt: 2, color: '#999' }}>
                  Submitted: {img.submittedAt ? new Date(img.submittedAt).toLocaleDateString() : 'N/A'}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
        
        {images.length === 0 && (
            <Typography sx={{ p: 2, color: 'gray' }}>No images found in the system.</Typography>
        )}
      </Grid>
    </Box>
  );
};

export default SuperAdminImages;